export default __webpack_public_path__ + "static/media/ej25.03b94ba5.png";